import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Mail, Users } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { UploadButton } from './RecordHelpers';

export const MeetingDocsTab = ({ noticeLogs, proxyLogs, term, onUploadOpen }) => (
  <div className="space-y-6">
    <div className="flex justify-end"><UploadButton tab="meeting-docs" defaultType="notice" onOpen={onUploadOpen} /></div>
    {/* Notices */}
    <div>
      <h3 className="text-sm font-semibold text-[#1A1D21] mb-3 flex items-center gap-2"><Mail className="h-4 w-4 text-[#00A3A3]" />Notices</h3>
      {noticeLogs.filter(l => (l.recipient_name || '').toLowerCase().includes(term)).length === 0 ? (
        <p className="text-xs text-[#A8B1B9] italic">No notices sent yet</p>
      ) : (
        <Card className="border-[#E2E6EA]"><CardContent className="p-0"><div className="overflow-x-auto">
          <table className="w-full min-w-[500px]">
            <thead><tr className="border-b border-[#E2E6EA] bg-[#F8F9FA]">
              <th className="text-left p-2.5 text-[10px] font-medium text-[#5A6570]">Recipient</th>
              <th className="text-left p-2.5 text-[10px] font-medium text-[#5A6570]">Email</th>
              <th className="text-left p-2.5 text-[10px] font-medium text-[#5A6570]">Mode</th>
              <th className="text-left p-2.5 text-[10px] font-medium text-[#5A6570]">Sent</th>
              <th className="text-left p-2.5 text-[10px] font-medium text-[#5A6570]">Status</th>
            </tr></thead>
            <tbody>
              {noticeLogs.filter(l => (l.recipient_name || '').toLowerCase().includes(term)).map(l => (
                <tr key={l.id} className="border-b border-[#E2E6EA] last:border-0">
                  <td className="p-2.5 text-xs font-medium text-[#1A1D21]">{l.recipient_name}</td>
                  <td className="p-2.5 text-xs text-[#5A6570]">{l.recipient_email}</td>
                  <td className="p-2.5 text-xs text-[#5A6570] capitalize">{l.mode}</td>
                  <td className="p-2.5 text-xs text-[#5A6570]">{l.sent_at ? format(parseISO(l.sent_at), 'MMM d, h:mm a') : '-'}</td>
                  <td className="p-2.5"><Badge className="bg-green-100 text-green-700 text-[10px]">Delivered</Badge></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div></CardContent></Card>
      )}
    </div>
    {/* Attendance */}
    <div>
      <h3 className="text-sm font-semibold text-[#1A1D21] mb-3 flex items-center gap-2"><Users className="h-4 w-4 text-[#00A3A3]" />Attendance</h3>
      <p className="text-xs text-[#A8B1B9] italic">Attendance records are stored within each meeting's Live Console</p>
    </div>
    {/* Proxies */}
    <div>
      <h3 className="text-sm font-semibold text-[#1A1D21] mb-3 flex items-center gap-2"><Users className="h-4 w-4 text-[#F58A26]" />Proxies</h3>
      {proxyLogs.length === 0 ? (
        <p className="text-xs text-[#A8B1B9] italic">No proxies recorded yet</p>
      ) : (
        <div className="space-y-2">
          {proxyLogs.map(p => (
            <Card key={p.id} className="border-[#E2E6EA]"><CardContent className="p-3 flex items-center gap-3">
              <Users className="h-4 w-4 text-[#F58A26]" />
              <div className="flex-1"><p className="text-xs text-[#1A1D21]">Shares: {(p.shares_covered || 0).toLocaleString()}</p></div>
              <Badge className={p.is_valid ? 'bg-green-100 text-green-700 text-[10px]' : 'bg-red-100 text-red-700 text-[10px]'}>{p.is_valid ? 'Valid' : 'Revoked'}</Badge>
            </CardContent></Card>
          ))}
        </div>
      )}
    </div>
  </div>
);
